import { api } from '../../services/apiClient';

export interface AudienceMember {
  account_id: number; firstname: string; lastname: string;
  phone_prefix: string | null; phone_number: string | null; has_photo: number;
  days_since?: number; days_until?: number;
}
export interface AudienceResp {
  type: string; data: AudienceMember[];
  summary: { total: number; with_phone: number };
}

export type AudienceType = 'active' | 'inactive' | 'birthdays' | 'class';

export function getAudience(type: AudienceType, opts: { days?: number; class_id?: number } = {}) {
  const p = new URLSearchParams({ type });
  if (opts.days) p.set('days', String(opts.days));
  if (opts.class_id) p.set('class_id', String(opts.class_id));
  return api.get<AudienceResp>(`/members/audience?${p.toString()}`);
}

export interface Template { key: string; label: string; body: string; }

// Plantillas con variable {nombre}. El estudio = Let's Move.
export const TEMPLATES: Template[] = [
  {
    key: 'pago',
    label: 'Recordatorio de pago',
    body: 'Hola {nombre} 👋 Te recordamos que tu mensualidad en Let\'s Move está pendiente. ' +
      'Puedes pasar a cubrirla en recepción o por transferencia. ¡Gracias y nos vemos en clase! 💃',
  },
  {
    key: 'extranamos',
    label: 'Te extrañamos (inactivos)',
    body: 'Hola {nombre} 💖 ¡Te extrañamos en Let\'s Move! Hace un tiempo que no te vemos por el estudio. ' +
      'Nos encantaría que regresaras a bailar con nosotros. ¿Te gustaría que te contemos las clases disponibles?',
  },
  {
    key: 'cumple',
    label: 'Feliz cumpleaños',
    body: '¡Feliz cumpleaños {nombre}! 🎉🥳 De parte de toda la familia Let\'s Move te deseamos un día increíble. ' +
      '¡A celebrar bailando! 💃🕺',
  },
  {
    key: 'evento',
    label: 'Invitación a evento',
    body: 'Hola {nombre} 🎭✨ Te invitamos a nuestro próximo evento de Let\'s Move. ' +
      '¡No te lo puedes perder! Escríbenos para apartar tu lugar. 🎟️',
  },
  { key: 'libre', label: 'Mensaje libre', body: '' },
];

// ===== Mensajería interna 1-a-1 (Sección 6 / Módulo A) =====
export interface Thread {
  account_id: number; name: string; has_photo: number;
  last_at: string; unread: number | string; last_body: string | null; last_role: 'staff' | 'student' | null;
}
export interface ChatMessage {
  message_id: number; sender_role: 'staff' | 'student'; sender_id?: number;
  body: string; created_at: string; read_by_student?: number;
}
export interface ThreadResp {
  student: { account_id: number; name: string; has_photo: number; phone_prefix: string | null; phone_number: string | null };
  data: ChatMessage[];
}

export const getThreads = () => api.get<{ data: Thread[]; summary: { unread: number } }>('/messages/threads');
export const getThread = (accountId: number) => api.get<ThreadResp>(`/messages/thread/${accountId}`);
export const sendToStudent = (accountId: number, body: string) =>
  api.post<{ ok: true; message_id: number }>(`/messages/thread/${accountId}`, { body });
export const getMessagesUnread = () => api.get<{ unread: number }>('/messages/unread');
